import { useSearchParams } from "react-router-dom";
import { Plus } from "@phosphor-icons/react";
import InvoiceEditor from "./InvoiceEditor";
import InvoiceList from "./InvoiceList";
import PriceHistory from "./PriceHistory";
import SupplierMappings from "./SupplierMappings";
import { btnPrimary } from "./util";

// Supplier SKU mapping view is hidden from navigation; mappings keep working in the background.
const VIEWS = [["invoices", "Invoices"], ["history", "Price History"]];

export default function InvoicePurchasing() {
    const [sp, setSp] = useSearchParams();
    const view = sp.get("v") || "invoices";
    const inv = sp.get("inv");
    const go = (patch) => setSp(Object.fromEntries(Object.entries({ v: view, inv, ...patch }).filter(([, x]) => x)));
    const open = (id) => go({ v: "invoices", inv: id });
    if (inv) return <InvoiceEditor key={inv} id={inv} onBack={() => go({ inv: null })} onSaved={(id) => inv === "new" && setSp({ v: "invoices", inv: id }, { replace: true })} onOpen={(id) => go({ inv: id })} />;
    return (
        <div className="space-y-4" data-testid="invoice-purchasing">
            <h1 className="font-serif text-3xl text-ink" data-testid="purchases-title">Purchases</h1>
            <div className="flex items-end justify-between gap-2 border-b border-mist">
                <div className="flex gap-1">
                    {VIEWS.map(([k, l]) => (
                        <button key={k} type="button" onClick={() => go({ v: k })} className={`px-2 sm:px-3 py-2 text-[11px] sm:text-xs uppercase tracking-wider sm:tracking-widest whitespace-nowrap border-b-2 -mb-px ${view === k ? "border-sage-dark text-ink" : "border-transparent text-neutral-500"}`} data-testid={`invoice-view-${k}`}>{l}</button>
                    ))}
                </div>
                <button type="button" className={`${btnPrimary} mb-1.5 shrink-0`} onClick={() => open("new")} data-testid="invoice-new-btn"><Plus size={14} /> New Invoice</button>
            </div>
            {view === "invoices" && <InvoiceList onOpen={open} />}
            {view === "history" && <PriceHistory onOpen={open} />}
            {view === "mapping" && <SupplierMappings />}
        </div>
    );
}
